import React from 'react';
import { 
    LoginHeaderBlock, 
    CloseBtn,
    LoginTextBlock,
    LoginTitle,
    LoginDescription
} from './style'

import close_icon from 'images/close_icon.png';

const LoginHeader = () => {
    return(
        <LoginHeaderBlock>
            <CloseBtn to='/'>
                <img src={close_icon} alt={"close button for login page"}/>
            </CloseBtn>
            <LoginTextBlock>
                <LoginTitle>로그인</LoginTitle>
                <LoginDescription>오늘 하루도 Motiners와 함께해요:)</LoginDescription>
            </LoginTextBlock>
        </LoginHeaderBlock>
    )
}

export default LoginHeader;